{
	"pkg": {},
	"help": "",
	"title": true,
	"version": "",
	"updates": true,
	"argv": null,
	"options": {}
}
